

    import Vue from "vue";
    import Component from "vue-class-component";
    import { VForm } from "@/vForm";
    import { Prop, Ref, Watch } from "vue-property-decorator";
    import * as toastr from "toastr";
    import ApiButton from "@/vue/components/ApiButton.vue";
    import PrimaryButton from "@/vue/components/PrimaryButton.vue";
    import Utils from "@/utilities/Utils";
    import ApiClient from "@/utilities/ApiClient";
    import { Visit } from "@/model/Visit";

    interface ISendResponse {
        emailFailed: boolean;
        isExpired: boolean;
        isWrongCode: boolean;
        isSuccess: boolean;
    }

    @Component({ components: { ApiButton, PrimaryButton } })
    export default class Contact extends Vue {

        contact = {
            name: "",
            email: "",
            phone: "",
            message: "",
            captchaID: "",
            captchaText: "",
            visitID: ""
        };

        didJustSend = false;
        responseErrorMessage = "";
        @Ref("contactForm") private readonly contactForm!: VForm;

        @Prop({ required: true })
        value!: boolean;

        @Prop({ required: true })
        visit!: Visit;

        @Watch("visit", { immediate: true, deep: true })
        onVisitChange() {
            this.contact.visitID = this.visit.id;
            this.contact.email = this.visit.email;
            this.contact.name = `${this.visit.forename} ${this.visit.surname}`;
            console.log("CONTACT onVisitChange - contact: ", this.contact);
        }

        hide () {
            this.$emit('input', false);
            this.didJustSend = false;
            this.contact.message = "";
        }

        validateEmail(email: string): string|boolean {
            if(Utils.isEmptyOrWhitespace(email)) return "Please enter your email address";
            const isValid = String(email)
                .toLowerCase()
                .match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
            const result = !isValid ? "The email address is not valid" : true;
            return result;
        }

        async send(): Promise<void> {
            this.responseErrorMessage = "";
            if (!this.contactForm.validate()) {
                toastr.warning("Please fix highlighted issues", "Cannot Send");
                return;
            }
            const response: ISendResponse = await ApiClient.post("/api/contact/send", this.contact, "contact-send");
            if(response.isSuccess) {
                this.responseErrorMessage = "";
                this.didJustSend = true;
            }
            else {
                this.responseErrorMessage =
                    response.isExpired ? "Sorry, the code has expired" :
                    response.isWrongCode ? "Sorry, the code was incorrect" :
                    response.emailFailed ? "Sorry, the email could not be sent" :
                    "Unspecified error";
            }
        }

    }
